import { Vehicle } from "../../Interfaces/vehicle.type";
import getVehicleDataPush from "../getVehicleDataPush";

type ReportTypeAnalytics = "condition-report" | "assured-report";

const reportDataPush = (vehicle: Vehicle, reportType: ReportTypeAnalytics) => {
  const vehicleDataPush = getVehicleDataPush(vehicle);

  //@ts-ignore
  if (window.digitalData) {
    //@ts-ignore
    return digitalData.push({
      event: {
        name: "click",
        category: "button",
        label: reportType,
        action: "download",
        type: "pdf",
      },
      ...vehicleDataPush,
    });
  }
};

export default reportDataPush;
